export enum SituacaoIndicadorProcessamento {
  EM_EXECUCAO = 'EM_EXECUCAO',
  FALHA_PROCESSAMENTO = 'FALHA_PROCESSAMENTO',
  PROCESSADO = 'PROCESSADO',
}
